/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { FeatureFlag } from '@midas/shared/common';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as FeatureFlagsActions from './feature-flags.actions';

export const FEATURE_FLAGS_KEY = 'featureFlags';

export interface FeatureFlagsState {
  featureFlags: EntityState<FeatureFlag>;
  loaded: boolean;
  loading: boolean;
}

export const featureFlagsAdapter = createEntityAdapter<FeatureFlag>({
  selectId: (featureFlag) => featureFlag.featureName,
});

const initialState: FeatureFlagsState = {
  featureFlags: featureFlagsAdapter.getInitialState(),
  loaded: false,
  loading: false,
};

export const FeatureFlagsFeature = createFeature({
  name: FEATURE_FLAGS_KEY,
  reducer: createReducer(
    initialState,
    on(FeatureFlagsActions.getFeatureFlags, (state): FeatureFlagsState => {
      return {
        ...state,
        loading: true,
      };
    }),
    on(FeatureFlagsActions.getFeatureFlagsSuccess, (state, { featureFlags }): FeatureFlagsState => {
      return {
        featureFlags: featureFlagsAdapter.setAll(featureFlags, state.featureFlags),
        loaded: true,
        loading: false,
      };
    }),
  ),
});
